import React from 'react';

import { Stack, SxProps, Theme, useTheme } from '@mui/material';

export interface EmptyStateProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
}

const EmptyState = ({ children, style = {}, sx }: EmptyStateProps) => {
  const theme = useTheme();
  const gradient =
    theme.palette.mode === 'dark'
      ? `linear-gradient(180deg, ${theme.palette.background.paper} 6.17%, ${theme.palette.background.default} 93.75%)`
      : 'var(--gradient-gray, linear-gradient(180deg, #E9E9E9 6.17%, #FFF 93.75%))';

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      maxWidth="lg"
      minHeight="100px"
      borderRadius="8px 8px 0px 0px"
      sx={sx}
      data-testid="emptyState"
      style={{ background: gradient, ...style }}
    >
      {children}
    </Stack>
  );
};

export default EmptyState;
